import React, { useState } from "react";
import "./Footer.css";
import logo from "../images/logo.png";
import { Link } from "react-router-dom";
import { FaLinkedinIn, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";


const Footer = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Column 1: Logo + Social */}
        <div className="footer-col logo-col">
          <img src={logo} alt="Fanfaro Logo" />
          <p>
            Building reliable, sustainable products that help businesses grow
            with confidence.
          </p>

          <div className="social-icons">
            {/* <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a> */}

            <a
              href="https://www.facebook.com/profile.php?id=61579051466627"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/fanfaroindia?igsh=MXF4cWM3ZjlpenNkdg=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

           

            <a
              href="https://www.linkedin.com/company/fanfaro-india/people/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Products */}
        <div
          className={`footer-col accordion ${openSection === "products" ? "open" : ""
            }`}
        >
          <h4 onClick={() => toggleSection("products")}>
            Products <span className="arrow"></span>
          </h4>
          {/* <ul className="products-grid">
            <li>
              <Link to="/car">
                Engine Oils for Trucks & Buses
              </Link>
            </li>
            <li>
              <Link to="/car">
                Engine Oils for Trucks & Buses
              </Link>
            </li>
          </ul> */}
          <ul>
            <li><Link to="/products/engine-oils-for-cars-and-transporters">Engine Oils for Trucks & Buses</Link></li>
            <li><Link to="/products/engine-oils-for-motobikes-and-outboards">Engine oils for Motorbikes & Outboards</Link></li>
            <li><Link to="/products/operating-service-fluids">Service Fluids</Link></li>
            {/* <li><Link to="/products">Products</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/contact">Contact Us</Link></li> */}
          </ul>
        </div>

        {/* Quick Links */}
        <div
          className={`footer-col accordion ${openSection === "links" ? "open" : ""
            }`}
        >
          <h4 onClick={() => toggleSection("links")}>
            Quick Links <span className="arrow"></span>
          </h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/products">Products</Link></li>
            {/* <li><Link to="/blog">Blog</Link></li> */}
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div
          className={`footer-col accordion ${openSection === "contact" ? "open" : ""
            }`}
        >
          <h4 onClick={() => toggleSection("contact")}>
            Contact <span className="arrow"></span>
          </h4>
          <ul className="contact-info">
            <li>
              335, 2rd cross street, JP Nagar 8th Phase, Bengaluru 560076,
              Karnataka.
            </li>
            <li>
              <a href="mailto:info@fanfaro.in">info@fanfaro.in</a>
            </li>
            <li>
              <a href="tel:+917204731100">+91 72047 31100</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Fanfaro India. All rights reserved.
        </p>

        <div className="footer-links">
          <Link to="/privacy_policy">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
